<div class="c-package-header">
	{{#with package}}
		<div class="row">
			<div class="col-sm-8">
				<div class="package-name-wrapper">
					{{#if packageNameAsLink}}
						<a href="/package/npm/{{name}}" on-click="@this.handlePageNameClick(name)" class="package-name">{{name}}</a>
					{{else}}
						<h1>{{name}}</h1>
					{{/if}}

					{{#if showDownloads}}
						<span class="package_downloads-amount" title="Downloads">
							<span>{{jsDelivrHits ? _.formatToShortNumber(jsDelivrHits) : '< 100'}}</span>
							<span>downloads</span>
						</span>
					{{/if}}
				</div>

				<div class="package-info">
					{{#if ~/type === 'gh'}}
						<a target="_blank" rel="noopener noreferrer" href="https://github.com/{{owner.name}}" class="package-owner">
							<img width="20" height="20" src="{{_.optimizeSrc(owner.avatar)}}">
							<span>{{owner.name}}</span>
						</a>
					{{else}}
						<a href="/?query=author%3A%20{{owner.name}}" class="package-owner">
							<img width="20" height="20" src="{{_.optimizeSrc(owner.avatar)}}" loading="lazy">
							<span>{{owner.name}}</span>
						</a>
					{{/if}}

					<div class="sub-info">
						{{#if popular}}
							<span class="sub-info_package sub-info_package_popular" title="Popular">popular</span>
						{{/if}}

						{{#if moduleTypes.indexOf('esm') !== -1}}
							<span class="sub-info_package sub-info_package_esm" on-click="@this.setTypeFilter('esm')" title="ESM">esm</span>
						{{/if}}

						{{#if moduleTypes.indexOf('cjs') !== -1}}
							<span class="sub-info_package sub-info_package_cjs" on-click="@this.setTypeFilter('cjs')" title="CJS">cjs</span>
						{{/if}}

						{{#if moduleTypes.indexOf('unknown') !== -1}}
							<span class="sub-info_package sub-info_package_js" on-click="@this.setTypeFilter('js')" title="JS">js</span>
						{{/if}}

						{{#if styleTypes.indexOf('none') === -1}}
							<span class="sub-info_package sub-info_package_styles" on-click="@this.setStyleFilter('styles')" title="Styles">Styles</span>
						{{/if}}

						{{#if deprecated}}
							<span class="sub-info_package sub-info_package_deprecated" title="Deprecated">deprecated</span>
						{{/if}}

						{{#if showSearchElements}}
							{{#unless packageVersionsNotFound}}
								<span class="sub-info_package sub-info_package_neutral" title="{{version}}">
									<span>Version</span>
									<span>{{version}}</span>
								</span>
							{{/unless}}

							{{#if license}}
								<span class="sub-info_package sub-info_package_neutral" title="{{_.unescapeHtml(license)}}">
									<span>License</span>
									<span>{{_.unescapeHtml(license)}}</span>
								</span>
							{{/if}}
						{{/if}}
					</div>
				</div>
			</div>

			<div class="col-sm-4">
				<div class="package-buttons">
					{{#if !~/type || ~/type === 'npm'}}
						{{#if homepage}}
							<a target="_blank" rel="noopener noreferrer nofollow" href="{{homepage}}" class="button" title="Homepage">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/icons/globe.svg"
									alt="{{name}} JS library homepage"
									title="{{name}} homepage">
							</a>
						{{/if}}

						{{#if githubRepo}}
							<a target="_blank"
								rel="noopener noreferrer"
								href="https://github.com/{{githubRepo.user}}/{{githubRepo.project}}/"
								class="button"
								title="GitHub">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/icons/github.svg"
									alt="{{name}} JS library on GitHub"
									title="{{name}} on GitHub">
							</a>
						{{/if}}

						<a target="_blank"
							rel="noopener noreferrer"
							href="https://www.npmjs.com/package/{{name}}"
							class="button"
							title="npm">
							<img width="20"
								height="20"
								src="{{@shared.assetsHost}}/img/icons/npm.svg"
								alt="{{name}} JS library on npm"
								title="{{name}} on npm">
						</a>

						<a rel="noopener noreferrer"
							href="https://registry.npmjs.org/{{name}}/-/{{name.split('/').slice(-1)[0]}}-{{~/version}}.tgz"
							class="button"
							title="Download">
							<img width="20"
								height="20"
								src="{{@shared.assetsHost}}/img/icons/download.svg"
								alt="Download {{name}} JS library"
								title="Download {{name}}">
						</a>
					{{else}}
						<a target="_blank"
							rel="noopener noreferrer"
							href="https://github.com/{{githubRepo.user}}/{{githubRepo.project}}/"
							class="button"
							title="GitHub">
							<i class="fa fa-github" aria-hidden="true"></i>
						</a>
					{{/if}}
				</div>

				{{#if showDownloads}}
					<span class="package_downloads-amount wide-screen" title="Downloads">
						<span>{{jsDelivrHits ? _.formatToShortNumber(jsDelivrHits) : '< 100'}}</span>
						<span>downloads</span>
					</span>
				{{/if}}
			</div>
		</div>

		<p class="package-description">
			{{{description}}}
		</p>

		<div class="package-header-bottom">
			<div class="horizontal-divider-16"></div>
			<div class="col-xs-12">
				{{#unless packageVersionsNotFound}}
					<span title="{{version}}">
						Version
						<span>{{version}}</span>
					</span>
				{{/unless}}

				{{#if license}}
					<span title="{{_.unescapeHtml(license)}}">
						License
						<span>{{_.unescapeHtml(license)}}</span>
					</span>
				{{/if}}

				{{#if ~/vulnerabilities !== undefined}}
					<span title="view details at snyk.io">
						<a rel="nofollow noopener" href="{{~/vulnerabilitiesUrl}}" target="_blank">
							Vulnerabilities <span>{{~/vulnerabilities}}</span>
						</a>
					</span>
				{{/if}}
			</div>
		</div>

		<div class="package-buttons-mobile">
			{{#if !~/type || ~/type === 'npm'}}
				<div>
					{{#if homepage}}
						<a target="_blank"
							rel="noopener noreferrer nofollow"
							href="{{homepage}}"
							class="button"
							title="Homepage">
							<img width="20"
								height="20"
								src="{{@shared.assetsHost}}/img/icons/globe.svg"
								alt="{{name}} JS library homepage"
								title="{{name}} homepage">
						</a>
					{{else}}
						<img width="20"
							height="20"
							src="{{@shared.assetsHost}}/img/icons/globe.disabled.svg"
							alt="{{name}} has no homepage"
							title="{{name}} has no homepage">
					{{/if}}
				</div>

				<div>
					{{#if githubRepo}}
						<a target="_blank"
							rel="noopener noreferrer"
							href="https://github.com/{{githubRepo.user}}/{{githubRepo.project}}/"
							class="button"
							title="GitHub">
							<img width="20"
								height="20"
								src="{{@shared.assetsHost}}/img/icons/github.svg"
								alt="{{name}} JS library on GitHub"
								title="{{name}} on GitHub">
						</a>
					{{else}}
						<img width="20"
							height="20"
							src="{{@shared.assetsHost}}/img/icons/github.disabled.svg"
							alt="{{name}} JS library on GitHub"
							title="{{name}} on GitHub">
					{{/if}}
				</div>

				<div>
					<a target="_blank"
						rel="noopener noreferrer"
						href="https://www.npmjs.com/package/{{name}}"
						class="button"
						title="npm">
						<img width="20"
							height="20"
							src="{{@shared.assetsHost}}/img/icons/npm.svg"
							alt="{{name}} JS library on npm"
							title="{{name}} on npm">
					</a>
				</div>

				<div>
					<a rel="noopener noreferrer"
						href="https://registry.npmjs.org/{{name}}/-/{{name.split('/').slice(-1)[0]}}-{{~/version}}.tgz"
						class="button"
						title="Download">
						<img width="20"
							height="20"
							src="{{@shared.assetsHost}}/img/icons/download.svg"
							alt="Download {{name}} JS library"
							title="Download {{name}}">
					</a>
				</div>
			{{else}}
				<a target="_blank"
					rel="noopener noreferrer"
					href="https://github.com/{{githubRepo.user}}/{{githubRepo.project}}/"
					class="button"
					title="GitHub">
					<i class="fa fa-github" aria-hidden="true"></i>
				</a>
			{{/if}}
		</div>

		{{#if keywords}}
			<div class="package-keywords_title">Keywords</div>

			<div class="package-keywords_list">
				{{#each keywords.slice(0, 15)}}
					<span class="package-keywords_list_item" title="{{this}}">{{this}}</span>
				{{/each}}
			</div>
		{{/if}}
	{{/with}}
</div>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');

	component.exports = {
		data () {
			return {
				_,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				if (this.get('type') === 'npm') {
					this.observe('version', (newValue) => {
						if (newValue) {
							http.fetchPackageVulnerabilities(this.get('name'), newValue).then((data) => {
								this.set('vulnerabilities', data.vulns);
								this.set('vulnerabilitiesUrl', data.url);
							}).catch((error) => {
								this.set('vulnerabilities', undefined);
								console.error('Failed to fetch vulnerability info', error);
							});
						}
					});
				}
			}
		},
		setTypeFilter (filterBy) {
			if (filterBy === this.get('filterType')) {
				this.set('filterType', '');
			} else {
				this.set('filterType', filterBy);
			}
		},
		setStyleFilter (filterBy) {
			if (filterBy === this.get('filterStyle')) {
				this.set('filterStyle', '');
			} else {
				this.set('filterStyle', filterBy);
			}
		},
		handlePageNameClick (name) {
			this.event.original.preventDefault();
			this.event.original.stopPropagation();

			// make sure scrollY is at 0 when page is rendered
			window.scrollTo(0, 0);
			setTimeout(() => window.scrollTo(0, 0), 0);

			// navigate to the Package page
			app.router.dispatch(`/package/npm/${name}`);
		},
	};
</script>
